module.exports = __webpack_public_path__ + "img/Menu-05.8a28c515.png";